import { request } from '../utils/request'

const baseUrl = 'https://se-main-gqi6flraoa-uc.a.run.app/main/';

export function getModels(token) {
    // console.log('Models: ', token)
    return request({
        method: 'get',
        url: baseUrl + `models/`,
        headers: {
            'Authorization': token
        }
    })
}

export function getModelData(token, modelId) {
    return request({
        method: 'get',
        url: baseUrl + `models/${modelId}`,
        headers: {
            'Authorization': token
        }
    })
}

export function getStatsModel(token, modelId) {
    return request({
        method: 'get',
        url: baseUrl + `models/${modelId}/stats`,
        headers: {
            'Authorization': token
        }
    })
}

export function getTrendModel(token, modelId) {
    return request({
        method: 'get',
        url: baseUrl + `models/${modelId}/trend`,
        headers: {
            'Authorization': token
        }
    })
}

export function getPingModel(token, userId, modelId) {
    // console.log(token, userId, modelId);
    return request({
        method: 'get',
        url: baseUrl + `models/${modelId}/ping`,
        headers: {
            'Authorization': token
        },
        params: {
            user_id: userId
        }
    })
}